import { useNavigate, useLocation } from "react-router-dom";

const FloatingCreateButton = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Hide on certain pages
    const hideOn = ["/service/new", "/mypage/edit-profile", "/setting", "/admin", "/login", "/signup"];
    if (hideOn.some(path => location.pathname.startsWith(path))) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none mobile:bottom-16">
            <div className="max-w-[860px] mx-auto px-6 pb-8 flex justify-end mobile:px-4 mobile:pb-4">
                <button
                    id="floating-sell-button"
                    onClick={() => navigate("/service/new")}
                    className="pointer-events-auto
                        bg-gradient-to-r from-primary-500 to-violet-500
                        text-white font-bold text-[13px]
                        px-5 py-3.5 rounded-full
                        shadow-lg shadow-primary-500/30
                        hover:shadow-xl hover:shadow-primary-500/40
                        hover:scale-105
                        active:scale-95
                        transition-all duration-200 ease-out
                        flex items-center gap-2"
                >
                    <span className="text-lg leading-none">+</span>
                    <span>내 시간 팔기</span>
                </button>
            </div>
        </div>
    );
};

export default FloatingCreateButton;
